<template>
  <div id="chartDiv" ref="chart">
    <div @touchstart="back"  @click="back" class="back" v-if="parentInfo.length > 1">返 回</div>
    <Chart :brick="true" :extendData="extendData" :height="height"
           :id="id" :option="option"
           :width="width" @echartsMapClick="echartsMapClick"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';
import echarts from 'echarts';
import AMapJS from 'amap-js';
import {getSpaceByCityCodeAndLevel} from "@/network/space-info";

export default {
  name: "BrickMapChart",
  components: {Chart},
  props: {
    data: null,
    extendData: null,
  },
  mounted() {
    this.getSpaceByCityCodeAndLevel(100000, null);
  },
  data() {
    return {
      id: "chart-panel",
      width: '100%',
      height: '100%',
      option: {},
      // 创建AMapJSAPI Loader
      amapLoader: new AMapJS.AMapLoader({
        // 30637235fc3837887a9f8593d49daba4
        key: '30637235fc3837887a9f8593d49daba4',
        version: '1.4.15',
        plugins: [],
      }),
      // 创建AMapUI Loader
      amapuiLoader: new AMapJS.AMapUILoader({version: '1.0'}),
      parentInfo: [
        {
          cityName: '全国',
          level: 'china',
          code: 100000,
        },
      ],
      geoJson: {
        features: [],
      },
      spaceMap: {}
    };
  },
  watch: {
    data() {

    }
  },
  methods: {
    //返回事件
    back() {
      if (this.parentInfo.length === 1) {
        return;
      }
      this.parentInfo.pop()
      this.getSpaceByCityCodeAndLevel(this.parentInfo[this.parentInfo.length - 1].code, this.parentInfo[this.parentInfo.length - 1].level)
    },
    async getGeoJson(adcode) {
      await this.amapLoader.load()
      await this.amapuiLoader.load()
      let that = this
      AMapUI.loadUI(['geo/DistrictExplorer'], DistrictExplorer => {
        var districtExplorer = new DistrictExplorer()
        districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
          if (error) {
            console.error(error);
            return;
          }
          let Json = areaNode.getSubFeatures()
          if (Json.length > 0) {
            that.geoJson.features = Json
          } else if (Json.length === 0) {
            that.geoJson.features = that.geoJson.features.filter(item => item.properties.adcode === adcode)
            if (that.geoJson.features.length === 0) return
          }
          that.getMapData()
        });
      })
    },
    //获取空间数据
    getSpaceByCityCodeAndLevel(cityCode, level) {
      let code = cityCode;
      //天津
      if (cityCode === 120000) {
        level = 'city'
        code = 120100
      } else if (cityCode === 110000) {
        //北京
        level = 'city'
        code = 110100
      } else if (cityCode === 310000) {
        //上海
        level = 'city'
        code = 310100
      }
      this.spaceMap = {}
      getSpaceByCityCodeAndLevel(code, level).then(res => {
        if (res.code === 0) {
          this.spaceMap = res.data
        }
        this.getGeoJson(cityCode)
      })
    },
    //获取数据 拼接，获取近五年的数据
    getMapData() {
      let mapData = []
      let pointData = []
      let that = this
      this.geoJson.features.forEach(item => {
        if (Object.keys(that.spaceMap).length > 0) {
          if (that.spaceMap[item.properties.adcode] !== undefined) {
            const spaceInfos = that.spaceMap[item.properties.adcode].filter(item => item.type !== 1);
            if (spaceInfos.length > 0) {
              mapData.push({
                name: item.properties.name,
                value: spaceInfos.length,
                level: item.properties.level,
                cityCode: item.properties.adcode,
                spaceInfos: spaceInfos
              })
              pointData.push({
                name: item.properties.name,
                value: [item.properties.center[0], item.properties.center[1], spaceInfos.length],
                level: item.properties.level,
                cityCode: item.properties.adcode,
                spaceInfos: spaceInfos
              })
            }
          }
        }
      })
      this.initEchartMap(mapData, pointData)
    },


    //渲染echarts
    initEchartMap(mapData, pointData) {
      //这里做个切换，全国的时候才显示南海诸岛  只有当注册的名字为china的时候才会显示南海诸岛
      if (this.parentInfo.length === 1) {
        echarts.registerMap('china', this.geoJson); //注册
      } else {
        echarts.registerMap('map', this.geoJson); //注册
      }

      this.option = {
        timeline: {
          show: false
        },
        baseOption: {
          tooltip: {
            trigger: "item",
          },
          geo: {
            map: this.parentInfo.length === 1 ? 'china' : 'map',
            tooltip: {
              trigger: 'item',
              formatter: (p) => {
                let val = p.value[2];
                if (window.isNaN(val)) {
                  val = 0;
                }
                let txtCon =
                  "<div style='text-align:left'>" + p.name + ": " + val + '个</div>';
                return txtCon;
              }
            },
            label: {
              normal: {
                show: false,
                color: "rgb(249, 249, 249)", //省份标签字体颜色
                formatter: p => {
                  switch (p.name) {
                    case '内蒙古自治区':
                      p.name = "内蒙古"
                      break;
                    case '西藏自治区':
                      p.name = "西藏"
                      break;
                    case '新疆维吾尔自治区':
                      p.name = "新疆"
                      break;
                    case '宁夏回族自治区':
                      p.name = "宁夏"
                      break;
                    case '广西壮族自治区':
                      p.name = "广西"
                      break;
                    case '香港特别行政区':
                      p.name = "香港"
                      break;
                    case '澳门特别行政区':
                      p.name = "澳门"
                      break;
                    default:
                      break;
                  }
                  return p.name;
                }
              },
              emphasis: {
                show: true,
                color: '#f75a00',
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#3a7fd5',
                borderColor: '#0a53e9',//线
                shadowColor: '#092f8f',//外发光
                shadowBlur: 20
              },
              emphasis: {
                areaColor: '#0a2dae',//悬浮区背景
              }
            },
            // itemStyle: {
            //   normal: {
            //     areaColor: '#24CFF4',
            //     borderColor: '#53D9FF',
            //     borderWidth: 1.3,
            //     shadowBlur: 15,
            //     shadowColor: 'rgb(58,115,192)',
            //     shadowOffsetX: 7,
            //     shadowOffsetY: 6,
            //   },
            //   emphasis: {
            //     areaColor: '#8dd7fc',
            //     borderWidth: 1.6,
            //     shadowBlur: 25,
            //   }
            //
            // },
          },
          series: [{
            name: '机房个数',
            type: 'map',
            geoIndex: 0,
            map: this.parentInfo.length === 1 ? 'china' : 'map',
            roam: true,
            zoom: 1.3,
            tooltip: {
              trigger: "item",
              formatter: p => {
                let val = p.value;
                if (p.name === '南海诸岛') return
                if (window.isNaN(val)) {
                  val = 0;
                }
                let txtCon =
                  "<div style='text-align:left'>" + p.name + ": " + val + '个</div>';
                return txtCon;
              }
            },
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              }
            },
            data: mapData,

          },
            //   {
            //   name: '散点',
            //   type: 'effectScatter',
            //   coordinateSystem: 'geo',
            //   rippleEffect: {
            //     brushType: 'fill'
            //   },
            //   itemStyle: {
            //     normal: {
            //       color: '#F4E925',
            //       shadowBlur: 10,
            //       shadowColor: '#333'
            //     }
            //   },
            //   data: pointData,
            //   symbolSize: 10,
            //   // symbolSize: function (val) {
            //   //   console.log(val,"----------va;");
            //   //   let value = val[2]
            //   //   if (value === mapData[0].value) {
            //   //     return 11
            //   //   }
            //   //   return 10
            //   // },
            //   showEffectOn: 'render', //加载完毕显示特效
            // },
            {
              name: 'Top 5',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'pin',
              symbolSize: [30, 30],
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: '#fff',
                    fontSize: 9,
                  },
                  formatter(value) {
                    return value.data.value[2]
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: '#D8BC37', //标志颜色
                }
              },
              data: pointData,
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke'
              },
              hoverAnimation: true,
              zlevel: 1
            },
          ]
        },
      }
    },
    //echarts点击事件
    echartsMapClick(params) {
      console.log(params.data, "====params.data===");
      if (!params.data) {
        return
      } else {
        let data = params.data
        //如果当前是最后一级，那就直接return
        if (this.parentInfo[this.parentInfo.length - 1].code === params.data.cityCode) {
          let params = {
            id: data.spaceInfos[0].id,
            title: data.spaceInfos[0].cnName,
          }
          this.$emit("spaceChoose", params)
          return
        }
        this.getSpaceByCityCodeAndLevel(data.cityCode, data.level);
        this.parentInfo.push({
          cityName: data.name,
          level: data.level,
          code: data.cityCode
        })
      }
    }
  }
}
</script>

<style scoped>
.back {
  position: absolute;
  left: 35px;
  top: 40px;
  color: rgb(179, 239, 255);
  font-size: 0.8rem;
  cursor: pointer;
  z-index: 100;
}
</style>
